import desktopDeviceIconLight from './icons/desktop-device-light.svg';
import mobileDeviceIconLight from './icons/mobile-device-light.svg';
import tabletDeviceIconLight from './icons/tablet-device-light.svg';
import unknownDeviceIconLight from './icons/unknown-device-light.svg';
import desktopDeviceIconDark from './icons/desktop-device-dark.svg';
import mobileDeviceIconDark from './icons/mobile-device-dark.svg';
import tabletDeviceIconDark from './icons/tablet-device-dark.svg';
import unknownDeviceIconDark from './icons/unknown-device-dark.svg';

const ensureDate = (loginDate) => {
  const numVal = parseInt(loginDate, 10);
  if (Number.isNaN(numVal)) return 0;
  return numVal;
}

export const sortFn = (a, b) =>
  ensureDate(b.lastLoginDate) - ensureDate(a.lastLoginDate);

export const parseDate = (epoch, format) => {
  if (Number.isNaN(parseInt(epoch, 10))) return '';

  const date = new Date(epoch);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const time = date.toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
  });

  const formatMap = {
    'DD-MM-YYYY': `${day}/${month}/${year}`,
    'YYYY-MM-DD': `${year}/${month}/${day}`,
    'MM-DD-YYYY': `${month}/${day}/${year}`,
  };

  const dateStr = formatMap[format] || formatMap['MM/DD/YYYY'];
  return `${dateStr} ${time}`;
};

export const deviceIconMap = {
  desktop: {
    light: desktopDeviceIconLight,
    dark: desktopDeviceIconDark,
  },
  mobile: {
    light: mobileDeviceIconLight,
    dark: mobileDeviceIconDark,
  },
  tablet: {
    light: tabletDeviceIconLight,
    dark: tabletDeviceIconDark,
  },
  unknown: {
    light: unknownDeviceIconLight,
    dark: unknownDeviceIconDark,
  },
};

export const getDeviceIcon = (deviceType) => {
  const icon = deviceIconMap[deviceType] || deviceIconMap.unknown;
  return {
    iconSrc: icon.light,
    iconSrcDark: icon.dark,
  };
};
